<div class="loader-container" [class.loader-inline]="inline">
  <div class="flex items-center justify-center"
       [ngClass]="inline ? 'flex-row gap-3' : 'flex-col gap-10'">
    <div class="loader"></div>
    <p *ngIf="message" class="loader-message text-lg font-medium">
      {{message}}
    </p>
  </div>
</div>